module.exports = {
  "country": "NO",
  "artist": "Jahn Teigen",
  "song": "Do-Re-Mi",
  "year": "1983",
  "place": "9",
  "spotify": "1CN16UGl4UCzZPMHpHreBT"
};